/**
 * Parse a date-like database value as a calendar date in the viewer's locale.
 *
 * Project start/target fields are stored as timestamptz for legacy reasons,
 * but the product treats them as date-only values. Parsing midnight UTC as an
 * instant shifts the displayed date backwards in western timezones.
 */
export function parseDateOnlyTimestamp(
  value: string | null | undefined
): number | null {
  if (!value) return null;
  const date = value.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
  if (!date) return null;
  return Date.parse(`${date}T12:00:00`);
}
